import { render } from "./SecondModal.vue?vue&type=template&id=f08162de"
import script from "./SecondModal.vue?vue&type=script&lang=js"
export * from "./SecondModal.vue?vue&type=script&lang=js"

import "./SecondModal.vue?vue&type=style&index=0&id=f08162de&lang=css"

import exportComponent from "../../../../../DIARC/pixonanimation.az/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__